import axios from 'axios'
import { Headers } from 'node-fetch'
import { GetSecretValueCommand, SecretsManagerClient } from '@aws-sdk/client-secrets-manager'
import { BaseClient } from '../../shared'

export class HrpBaseClient extends BaseClient {
    constructor(
        hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
        hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
        axiosOptions
    ) {
        super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)

        this.oauthResponse = null;
        this.tokenExpiration = null;
    }

    isTokenValid() {
        return this.oauthResponse &&
            this.tokenExpiration &&
            Date.now() < this.tokenExpiration;
    }

    async createSecureAxiosInstance(customHeaders = {}, contentType = null) {
        const isTokenValid = this.isTokenValid();

        if (
            this.secureAxiosInstance &&
            isTokenValid &&
            JSON.stringify(this.secureCustomHeaders) === JSON.stringify(customHeaders) &&
            JSON.stringify(this.secureContentType) === JSON.stringify(contentType)
        ) {
            return
        }

        if (!this.secretName)
            throw new Error("'secretName' must be defined")

        const secretsManagerClient = new SecretsManagerClient()

        const { SecretString } = await secretsManagerClient.send(
            new GetSecretValueCommand({ SecretId: this.secretName })
        );

        const secretObject = JSON.parse(SecretString)

        if (!secretObject.centivo) {
            throw new Error('Centivo is not defined on HRP secret key');
        }

        const centivoSecret = JSON.parse(secretObject.centivo);

        const oauthUrl = centivoSecret.oauthUrl;
        const clientId = centivoSecret.clientId;

        const headers = new Headers();
        headers.append("Content-Type", "application/x-www-form-urlencoded");
        headers.append(
            "Authorization",
            `Basic ${Buffer.from(clientId).toString('base64')}`
        );

        const urlencoded = new URLSearchParams();
        urlencoded.append("grant_type", "client_credentials");

        const requestOptions = {
            method: "POST",
            headers,
            body: urlencoded,
            redirect: "follow"
        };

        // @ts-ignore
        const res = await fetch(oauthUrl, requestOptions)

        if (!res.ok) {
            console.log(await res.text())
            throw new Error(`fetch error`, { cause: { res } });
        }

        const oauthResponse = await res.json();
        this.oauthResponse = oauthResponse;
        this.tokenExpiration =
            Date.now() + (this.oauthResponse.expires_in - 60) * 1000;

        this.secureCustomHeaders = customHeaders
        this.secureContentType = contentType

        this.secureAxiosInstance = axios.create({
            baseURL: this.url,
            headers: {
                "content-type": contentType ?? "application/json",
                Authorization: `Bearer ${oauthResponse.access_token}`,
                ...customHeaders
            }
        });
    }
}
